<template>
  <div>
    <vx-card title="Attachment" class="mb-base">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow"></div>
        <!-- <feather-icon icon="EditIcon" /> -->
      </div>
      <vs-table
        max-items="5"
        :data="data"
        :stripe="true"
        v-if="data != null"
        pagination
        search
      >
        <template slot="thead">
          <vs-th sort-key="attachmentType">Attachment Type</vs-th>
          <vs-th sort-key="fileName">File Name</vs-th>
          <!-- <vs-th sort-key="description">Description</vs-th> -->
          <vs-th sort-key="issuedDate">Issued Date</vs-th>
          <vs-th sort-key="expireDate">Expire Date</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].attachmentType">
              {{ data[indextr].attachmentType }}
            </vs-td>
            <vs-td :data="data[indextr].filePath">
              <a
                @click="downloadAttachment(data[indextr].fileName)"
                target="_blank"
                >{{ data[indextr].fileName }}</a
              >
            </vs-td>
            <!--  <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td> -->
            <vs-td :data="data[indextr].expireDate">
              {{ formatIssued(data[indextr].expireDate) }}
            </vs-td>
            <vs-td :data="data[indextr].expireDate">
              {{ formatExpire(data[indextr].expireDate) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <pre v-if="data == null">No data Available.</pre>
    </vx-card>
  </div>
</template>

<script>
import { apiConfig } from "../../services/config";
import { _vendorservice } from "../../services/vendorservices";
import { _blobservice } from "../../services/blobservice";
import { dateFormat, setExpireDate } from "../../services/utility";

export default {
  props: {
    propVendorUsername: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      apiURl: apiConfig,
      data: [
        {
          attachmentType: "",
          filePath: "",
          description: "",
          expireDate: new Date(),
        },
      ],
    };
  },
  created() {
    // Delay for Main get Username
    setTimeout(() => {
      this.getAttachment();
    }, 2000);
  },
  methods: {
    async getAttachment() {
      // console.log(this.propVendorUsername);
      this.data = await _vendorservice.GetVendorAttachment(
        this.propVendorUsername
      );
      // console.log("Attachment", this.data);
    },

    async downloadAttachment(filename) {
      // alert(filename);
      await _blobservice.GetBlob2(filename);
    },

    formatExpire(date) {
      // console.log(dateFormat(date), "-", dateFormat(setExpireDate(date, 6)));

      if (date != null) return dateFormat(setExpireDate(date, 6));

      return null;
    },

    formatIssued(date) {
      // console.log(dateFormat(date), "-", dateFormat(setExpireDate(date, 6)));

      if (date != null) return dateFormat(date);

      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
